import { all, put } from 'redux-saga/effects';
import { getContactGroups } from './actions';

function* bulkAddedToGroupSaga({ meta }) {
  yield all(meta.ids.map((id) => put(getContactGroups(id))));
}

export default function* root() {
  yield all([
    // takeLatest(resolved(BULK_ADD_TO_GROUP), bulkAddedToGroupSaga),
    // takeLatest(resolved(GET_CONTACTS), getContactGroupsSaga),
  ]);
}
